export default __webpack_public_path__ + "static/media/bg16.f73bfbfd.jpg";